module.exports = __webpack_public_path__ + "img/autospin_btn.ed1eba2c.png";